import EleTableEditor from './EleTableEditor'

export default EleTableEditor
